import * as actions from './slice'

const getTemplateList = {
  eventName: 'templateListAll',
  onStart: [{ action: actions.setFetchingTemplateList, redux: true }],
  onSuccess: [{ action: actions.getTemplateList, redux: true }]
}

const addTemplateList = {
  eventName: 'templateListAll',
  onSuccess: [{ action: actions.addTemplateList, redux: true }
  ]
}

const getParentTemplatesList = {
  eventName: 'templateList',
  onSuccess: [{ action: actions.getParentTemplatesList, redux: true }]
}

export {
  getTemplateList,
  addTemplateList,
  getParentTemplatesList
}
